import { mapDistanceClasses } from '../utils';

import { bibClassesStore } from '../stores';

export const setBibClassesStore = (data): void => {
  bibClassesStore.set(mapDistanceClasses(data));
};
